import JSONSchema from 'json-schema';

const isValueValid = <T extends {}>(value: T, schema: JSONSchema.JSONSchema7) => {
  const { valid } = JSONSchema.validate(value, schema);
  return valid;
};

export default isValueValid;
